
import { supabase } from '@/lib/supabase'
import { updateOrganizationSubscription } from './subscriptionUtils';

/**
 * Ajoute un utilisateur à une organisation
 */
export async function addUserToOrganization(orgId: string, userId: string, subscription_plan_id: string | undefined) {
  console.log('Ajout du membre à l\'organisation via RPC sécurisée:', orgId);
  
  try {
    // Check if member already exists
    const { data: existingMember, error: checkError } = await supabase
      .from('organization_members')
      .select('id')
      .eq('organization_id', orgId)
      .eq('user_id', userId)
      .maybeSingle();
      
    if (existingMember?.id) {
      console.log('L\'utilisateur est déjà membre de l\'organisation, id:', existingMember.id);
      return;
    }
    
    if (checkError) {
      console.log('Erreur lors de la vérification d\'appartenance à l\'organisation:', checkError);
    }
  
    // Use the secure RPC function to add the member
    const { data: memberData, error: memberRpcError } = await supabase.rpc(
      'secure_insert_organization_member_v2', 
      {
        p_organization_id: orgId,
        p_user_id: userId,
        p_role: 'owner'
      }
    );
    
    if (memberRpcError) {
      console.error('Erreur lors de l\'ajout sécurisé du membre via RPC:', memberRpcError);
      
      // Fallback to direct insert
      console.log('Tentative d\'insertion directe du membre');
      const { error: directInsertError } = await supabase
        .from('organization_members')
        .insert({
          organization_id: orgId,
          user_id: userId,
          role: 'owner'
        });
        
      if (directInsertError) {
        console.error('Échec de l\'insertion directe du membre:', directInsertError);
      } else {
        console.log('Membre ajouté avec succès via insertion directe');
      }
    } else {
      console.log('Membre ajouté à l\'organisation avec succès via RPC');
    }
    
    // If we have a subscription plan ID, make sure it's set on the organization
    if (subscription_plan_id) {
      await updateOrganizationSubscription(orgId, subscription_plan_id);
    }
  } catch (error) {
    console.error('Exception lors de l\'ajout du membre:', error);
  }
}
